export default __webpack_public_path__ + "static/media/ye.1f97c10b.svg";